import { Edit3, ExternalLink, MapPin, Trash2 } from "lucide-react";
import type { Shop } from "../types";
import { hasExactLocation } from "../utils";
import { displayValue } from "../../../shared/utils/format";

type ShopDetailPanelProps = {
  shop: Shop | null;
  onEditShop: (shop: Shop) => void;
  onDeleteShop: (shop: Shop) => void;
};

export function ShopDetailPanel({ shop, onEditShop, onDeleteShop }: ShopDetailPanelProps) {
  if (!shop) {
    return (
      <aside className="detail-panel empty-detail">
        <MapPin size={22} />
        <h2>Select a shop</h2>
        <p>Details, edit actions, and map coordinates will appear here.</p>
      </aside>
    );
  }

  const hasLocation = hasExactLocation(shop.shopLocation);
  const mapUrl = hasLocation
    ? `https://www.google.com/maps/search/?api=1&query=${shop.shopLocation.latitude},${shop.shopLocation.longitude}`
    : null;

  return (
    <aside className="detail-panel">
      <div className="section-heading">
        <div>
          <p className="eyebrow">{shop.source === "import" ? "Imported shop" : "Manual shop"}</p>
          <h2>{shop.shopName}</h2>
        </div>
        <span className={`status-badge ${shop.shopLocation.status}`}>{shop.shopLocation.status.replace("_", " ")}</span>
      </div>

      <dl className="details-list">
        <div>
          <dt>Phone</dt>
          <dd>{displayValue(shop.shopPhoneNumber)}</dd>
        </div>
        <div>
          <dt>Class</dt>
          <dd>{displayValue(shop.shopClass)}</dd>
        </div>
        <div>
          <dt>Governorate</dt>
          <dd>{displayValue(shop.shopGovenorate)}</dd>
        </div>
        <div>
          <dt>City</dt>
          <dd>{displayValue(shop.shopCity)}</dd>
        </div>
        <div>
          <dt>District</dt>
          <dd>{displayValue(shop.shopDistrict)}</dd>
        </div>
        <div>
          <dt>Street</dt>
          <dd>{displayValue(shop.shopStreet)}</dd>
        </div>
        <div>
          <dt>Location</dt>
          <dd>{displayValue(shop.shopLocation.addressText)}</dd>
        </div>
      </dl>

      <div className="detail-actions">
        <button type="button" className="secondary-button" onClick={() => onEditShop(shop)}>
          <Edit3 size={16} />
          Edit
        </button>
        <button type="button" className="danger-button" onClick={() => onDeleteShop(shop)}>
          <Trash2 size={16} />
          Delete
        </button>
        {mapUrl ? (
          <a className="ghost-button" href={mapUrl} target="_blank" rel="noreferrer">
            <ExternalLink size={16} />
            Open map
          </a>
        ) : null}
      </div>
    </aside>
  );
}
